import { render } from "./FooterComp.vue?vue&type=template&id=294329b4"
const script = {}

import "./FooterComp.vue?vue&type=style&index=0&id=294329b4&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__